import { useOptionsDomain } from "@/configurator/domain/hooks/useOptionsDomain";
import type { OptionsDomain } from "@/configurator/domain/hooks/useOptionsDomain";

export type OptionsPanelComponent = OptionsDomain & {
  /** The model row is only worth drawing when there is a choice to make. */
  showModels: boolean;
};

export function useOptionsPanelComponent(): OptionsPanelComponent {
  const options = useOptionsDomain();
  return { ...options, showModels: options.models.length > 1 };
}
